import { PageLoader, SEmptyState } from '@setvi/shared/components';
import { CompanyProductUserType } from '@setvi/shared/services/react-query/query/user/types';
import { Box } from '@material-ui/core';
import { Customer } from 'Services/MongoRealm/Types';
import { CustomerPreferencesInterface } from 'componentsV2/customer-preferences/interfaces';
import {
  PriceGroup,
  Product,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { DetailsContent } from './content';
import { useProductDetails } from './hooks';
import { useSalesKitStore } from './store';

export interface DetailsDialogProps {
  selectedProduct: Partial<Product>;
  selectedProducts?: Product[];
  selectedCustomerId?: Customer['_id'];
  selectedPriceGroup?: PriceGroup;
  defaultOpenedTab?: ProductDetailsTabsIds;
  userType?: CompanyProductUserType;
  client: any;
  readOnly?: boolean;
  canSelectProducts?: boolean;
  hideProductPrice?: boolean;
  priceLoading?: boolean;
  orderHistoryValues?: {
    accountId: string;
    addressId: string;
  };
  customerPreferences?: CustomerPreferencesInterface;
  onClose: () => void;
  handleProductSelect?: (isChecked: boolean, product: Product[]) => void;
  updateProduct?: (product: Product, newValues: Partial<Product>) => void;
  captureResourceAnalytics?: () => void;
  openProductDetails?: (
    product: any,
    defaultOpenedTab?: ProductDetailsTabsIds
  ) => void;
  handleEmail?: () => void;
  handleSelected?: () => void;
  handleCloseActionBar?: () => void;
}

export const ProductDetails = ({
  selectedProduct,
  selectedProducts,
  selectedCustomerId,
  selectedPriceGroup,
  orderHistoryValues,
  defaultOpenedTab,
  client,
  userType,
  readOnly = false,
  canSelectProducts,
  priceLoading,
  hideProductPrice = false,
  customerPreferences,
  handleProductSelect,
  onClose,
  updateProduct,
  captureResourceAnalytics,
  openProductDetails,
  handleEmail,
  handleSelected,
  handleCloseActionBar
}: DetailsDialogProps) => {
  const {
    product,
    customer,
    isLoading,

    handleProdctPrice
  } = useProductDetails({
    selectedProduct,
    selectedCustomerId,
    client,
    userType
  });

  const { resetSalesKitStore } = useSalesKitStore();

  if (!selectedProduct) return null;

  return (
    <Box
      overflow="hidden"
      display="flex"
      flex={1}
      style={{ background: '#F8F9FA' }}>
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          {product ? (
            <DetailsContent
              product={product}
              client={client}
              selectedCustomer={customer}
              selectedPriceGroup={selectedPriceGroup}
              readOnly={readOnly}
              defaultOpenedTab={defaultOpenedTab}
              selectedProducts={selectedProducts}
              canSelectProducts={canSelectProducts}
              hideProductPrice={hideProductPrice}
              orderHistoryValues={orderHistoryValues}
              customerPreferences={customerPreferences}
              priceLoading={priceLoading}
              handleProductSelect={handleProductSelect}
              captureResourceAnalytics={captureResourceAnalytics}
              updateProduct={(prod, newValues) => {
                handleProdctPrice(newValues);
                updateProduct?.(prod, newValues);
              }}
              openProductDetails={openProductDetails}
              closeDialog={() => {
                resetSalesKitStore();
                onClose();
              }}
              handleEmail={handleEmail}
              handleSelected={handleSelected}
              handleCloseActionBar={handleCloseActionBar}
            />
          ) : (
            <Box width="100%">
              <SEmptyState
                title="Product Not Found"
                subTitle="There is no product found with specified ID."
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
